import { render, staticRenderFns } from "./IndexView.vue?vue&type=template&id=52d957eb&scoped=true&"
import script from "./IndexView.vue?vue&type=script&lang=js&"
export * from "./IndexView.vue?vue&type=script&lang=js&"
import style0 from "./IndexView.vue?vue&type=style&index=0&id=52d957eb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d957eb",
  null
  
)

export default component.exports